import React from 'react';
import ReactDOM from 'react-dom/client';
import { ChainProfile } from '~/pages/Chain/Profile/ChainProfile';
import type { ChainProfileProps } from '~/types/Chain';

import '~/styles/main.scss';

interface WindowWithData extends Window {
  data: ChainProfileProps;
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
const data = (window as unknown as WindowWithData).data || {};

root.render(
  <React.StrictMode>
    <ChainProfile {...data} />
  </React.StrictMode>
);
